'use client'
import { useEffect, useState } from "react";
import { defaultSelfUser, SelfUserResponseType } from "@/types"
import { getSelf } from "@/app/api"
import { UpdateSelfUserForm } from "./update-self-user-form"
import { ConfirmPassword } from "@/components/ui";

export function ManageSelfUser() {
    const [userData, setUserData] = useState<SelfUserResponseType>()
    const [isOpen, setIsOpen] = useState<boolean>(true)

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getSelf()
                const userData = response?.data
                if (response !== undefined) {
                    setUserData(userData as SelfUserResponseType)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [])

    return (
        <div className="p-8">
            {isOpen &&
                <ConfirmPassword
                    user={userData?.identifier || ''}
                    name={userData?.name || ''}
                    message={"Confirme sua senha para prosseguir"}
                    onClose={() => setIsOpen(false)}
                />
            }
            <UpdateSelfUserForm user={userData || defaultSelfUser} />
        </div>

    )
}